module.exports = __webpack_public_path__ + "static/about_mobile_header-bbc1421cb7e4b3d059ff47fa3e4638ca.png";